document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.amb-tab');
  var panels = document.querySelectorAll('.amb-tab-panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.getAttribute('data-tab');
      tabs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      panels.forEach(function (p) { p.classList.remove('active'); });
      var targetPanel = document.querySelector('.amb-tab-panel[data-panel="' + target + '"]');
      if (targetPanel) targetPanel.classList.add('active');
      var title = document.querySelector('.amb-page-title');
      var subtitle = document.querySelector('.amb-page-subtitle');
      if (title && subtitle) {
        var h = {
          dashboard: ['Welcome back!', "Here's how you're doing this month."],
          campaigns: ['Campaign Creative', 'Download assets and talking points for current and upcoming campaigns.'],
          resources: ['Ambassador Resources', 'Guides, templates, and tools to help you create great content and grow your audience.'],
          faq: ['Frequently Asked Questions', 'Quick answers to the most common ambassador questions.']
        };
        if (h[target]) { title.textContent = h[target][0]; subtitle.textContent = h[target][1]; }
      }
    });
  });

  document.querySelectorAll('.amb-faq-item').forEach(function (item) {
    var btn = item.querySelector('.amb-faq-question');
    if (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.amb-faq-item').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
        item.classList.toggle('open');
      });
    }
  });

  document.querySelectorAll('.amb-campaign-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.getAttribute('data-campaign');
      document.querySelectorAll('.amb-campaign-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      document.querySelectorAll('.amb-campaign-card').forEach(function (c) { c.classList.remove('active'); });
      var tc = document.querySelector('.amb-campaign-card[data-campaign="' + target + '"]');
      if (tc) tc.classList.add('active');
    });
  });
});
